

























export default {
  name: 'Devices',
};
